export const getters = {
  analyst: state => state.analyst,
  analysts: state => state.analysts
}

const GET_ANALYSTS = 'analyst/analysts'

export const gettersTypes = {
  GET_ANALYSTS
}
export default getters



// WEBPACK FOOTER //
// ./src/store/module/analyst/getters.js